/*
* 商家管理
* */

import { get, post } from './axios'
import { get as getPoint } from './axios2'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/seller'
const RESOURCE_BASE_PATH = '/seller'


//  获取客户信息
export const getSellerInfo = p => get(`/taohd/current`, p);

// 短信转移获取当前的总条数
export const getShopInfo = p => get(`${RESOURCE_BASE_PATH}/getShopInfo`, p);

// 切换店铺
export const switchShop = p => post(`${RESOURCE_BASE_PATH}/switchShop`, p);

// 更新商家单价
export const updateUnitPrice = p => get(`${RESOURCE_BASE_PATH}/updateUnitPrice/${p}`);

// 返回旧系统
export const returnOldSystem = p => get(`${RESOURCE_BASE_PATH}/returnOldSystem`);

// 内容解密
export const decrypt = p => get(`${RESOURCE_BASE_PATH}/content/decrypt`,p);

// 获取用户菜单列表
export const getMenuList = p => postJson(`/public/queryThdMenu`,p);